<template>
  <div id="coachRegist" style="position:absolute;top:-10000px;left:-5000px">
    <ul
      v-for="(temp,num) in getShowTotal"
      :key="num"
      class="student_regist"
      style="display:flex;flex-wrap:wrap;list-style:none;page-break-after:always;margin:200px 0 0 0;padding:0 20px;"
    >
      <li
        v-for="(item,index) in list.slice(num * 4,(num + 1)*4)"
        :key="num + '_'+ index"
        style="border: 1px solid #979797;width: 370px;padding: 30px 10px 30px 20px;margin: 0 0 30px 30px;"
      >
        <section class="head_img" style="width:160px;height:200px;margin:0 auto;">
          <img style="width:100%;height:100%" :src="item.headImage" alt />
        </section>
        <section class="student_info_box" 
          style="display: flex;justify-content: space-between;margin-top: 20px;color: #444;">
          <ul class="student_info_left" style="width: 100%;margin:0;padding:0;">
            <li style="font-size: 16px;display: flex;align-items:flex-start;margin:0 0 10px 0;">
              <p class="left_width" style="flex: 1;margin:0;">
                姓名
                <span style="font-size: 14px;font-weight: 400;">{{item.name}}</span>
              </p>
              <p class="right_width" style="width:170px;margin:0;">
                性别
                <span style="font-size: 14px;font-weight: 400;">{{!item.gender?'女':'男'}}</span>
              </p>
            </li>
            <li style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p class="left_width" style="flex: 1;margin:0;">
                民族
                <span style="font-size: 14px;font-weight: 400;">{{item.nation}}</span>
              </p>
              <p class="right_width" style="width:170px;margin:0;">
                出生
                <span style="font-size: 14px;font-weight: 400;">{{item.birthday}}</span>
              </p>
            </li>
            <li style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;padding:0">
                学校
                <span style="font-size: 14px;font-weight: 400;">{{item.schoolName}}</span>
              </p>
            </li>
            <li style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;padding:0">
                类别
                <span style="font-size: 14px;font-weight: 400;">{{item.type === 1?'阳光体育':'竞技项目'}}</span>
              </p>
            </li>
            <li style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;padding:0">
                注册号
                <span style="font-size: 14px;font-weight: 400;">{{item.registerNumber}}</span>
              </p>
            </li>
            <li style="font-size: 16px;margin-bottom: 10px;display: flex;align-items: flex-start;">
              <p style="margin:0;padding:0">
                有效期
                <span style="font-size: 14px;font-weight: 400;">{{effectiveTime(item.trainingTime,item.trainingEndTime)}}</span>
              </p>
            </li>
          </ul>
        </section>
      </li>
    </ul>
  </div>
</template>
<script>
import { getCoachList } from "@/api/coach";
import { page } from "@/common/js/mixins";
import { method } from "@/utils/utils";
import registerData from "@/assets/json/register.json";
import { getSession } from "@/utils/storage";
export default {
  mixins: [page],
  data() {
    return {
      list: [],
      query: {
        keyword: ""
      },
      schoolName: JSON.parse(getSession("userInfo")).schoolName || ""
    };
  },
  computed: {
    // 打印，固定每页显示4个，根据list长度，获取显示总页数
    getShowTotal() {
      let num = 0;
      let length = this.list.length;
      if (length <= 4) num = 1;
      else {
        if (length / 4 > parseInt(length / 4)) {
          num = parseInt(length / 4) + 1;
        } else {
          num = parseInt(length / 4);
        }
      }
      return num;
    },
    // 筛选学制
    schoolSystem() {
      return data => {
        let label = "";
        registerData.educationalList.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 筛选组别
    registGroup() {
      return data => {
        let label = "";
        registerData.registGroup.filter(item => {
          if (item.value === data) {
            label = item.label;
          }
        });
        return label;
      };
    },
    // 有效期
    effectiveTime() {
      return (data, end) => {
        return data + " 至 " + end;
      };
    }
  },
  methods: {
    // 打印
    print() {
      var el = document.querySelector("#studentRegist"),
        iframe = document.createElement("IFRAME"),
        doc = null;
      iframe.setAttribute("id", "print-iframe");
      iframe.setAttribute(
        "style",
        "width:100%;font-size:20px;text-align:center"
      );
      document.body.appendChild(iframe);
      doc = iframe.contentWindow.document;
      doc.write(
        '<html><head><style type="text/css" media="all">ul{list-style:none} @page {size: auto; margin: 0mm 5mm;}</style></head><body style="zoom: 80%;">' +
          el.innerHTML +
          "</body></html>"
      );
      doc.close();
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getList();
    },
    // 获取列表数据
    getList() {
      getCoachList({
        ...this.query,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      })
        .then(res => {
          this.total = res.total;
          res.list.filter(item => {
            item.birthday = method.timeFormat(item.birthday, "utf");
            item.trainingTime = item.trainingTime
              ? method.timeFormat(item.trainingTime, "utf")
              : "";
            item.trainingEndTime = item.trainingEndTime
              ? method.timeFormat(item.trainingEndTime, "utf")
              : "";
          });
          this.list = [...res.list];
        })
        .catch(err => {});
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="less" scoped>
header {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  > span {
    font-size: 24px;
    color: #222;
    margin-right: 36px;
  }
}
.student_regist {
  display: flex;
  flex-wrap: wrap;
  > li {
    border: 1px solid #979797;
    width: 380px;
    padding: 30px 10px 30px 20px;
    margin: 0 16px 16px 0;
    .head_img {
      width: 160px;
      height: 200px;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .student_info_box {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      color: #444;
      .student_info_left,
      .student_info_right {
        width: 100%;
        li {
          font-size: 16px;
          margin-bottom: 10px;
          display: flex;
          font-weight: 600;
          align-items: flex-start;
          &.empty {
            visibility: hidden;
          }
          .right_width {
            width: 150px;
          }
          .left_width {
            flex: 1;
          }
          span {
            font-size: 14px;
            font-weight: 400;
          }
        }
      }
    }
  }
}
</style>